'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const openQuote = "„";
const closeQuote = "“";
const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1.10,
  slidesToScroll: 1,
  arrows:true,
  accessibility:false,
  focusOnSelect:true
};

var jsonData = require('./landingpagedata.json');

export default class QuoteContainer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Container>
        <SectionTitle>{jsonData.QuoteTexts.sectionTitle}</SectionTitle>
        <RowItem>
          <Slider {...sliderSettings}>
            {this._renderData()}
          </Slider>
        </RowItem>
        </Container>
    );
  }

  _renderData(){
    let result = [];
    let i = 0;
    jsonData.QuoteTexts.quotes.forEach( (eachItem) => {
      result.push(
          <QuoteCard style={cardContainerStyle}
            image={eachItem.imageSrc}
            author={eachItem.author}
            quote={eachItem.quote}
            moreInfoLink={eachItem.moreInfoLink}
            key={"CTAText"+ i++}
            />
      );
    });
  return (result);
  }
}


 class QuoteCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {quote, image, author,moreInfoLink} = this.props;
    return (
      <Card>
        <CardImageColumn>
          <img src={image} style={cardImageStyle}/>
          <ImageLabel>
            {this.addLineFeed(author,true)}
          </ImageLabel>
        </CardImageColumn>
        <QuoteTextColumn>
          {openQuote + quote + closeQuote}
          <MoreInfoLink link={moreInfoLink} />
        </QuoteTextColumn>
    </Card>
    );
  }

  addLineFeed(text,renderImageLabel){
    if(renderImageLabel){
      return text.split('\n').map((item, i) => {
          return <ImageLabelLineProd key={i}>{item}</ImageLabelLineProd>;
      });
    }
    else{
      return text.split('\n').map((item, i) => {
          return <p key={i}>{item}</p>;
      });
    }
  }
}

class MoreInfoLink extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {link} = this.props;

    if(link){
      return (
        <MoreInfoLinkStyle>
        <a href={link}>Nánar um verkefni</a>
        </MoreInfoLinkStyle>
      );
    }
    else{
      return(null);
    }
  }
}


/*
*  QuoteContainer styles
*/

const RowItem = styled.section`
  width: 100%;
  margin-bottom: 2rem;
`;

const Container = styled.section`
    overflow:hidden;
    position: relative;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    padding: 0 0 1.8rem;
    background: #e8e7e5;
`;

const SectionTitle = styled.section`
    display: flex;
    flex: 1;
    //height: 60px;
    margin: 20px 0px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    margin-left: 1.8rem;
    color: #5E7CA0;
    font-size: 1.3em;
    line-height: 1.2em;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardContainerStyle =  {
  padding: "20px 0 0",
  //alignItems:'center',
//  alignContent:'center'
};

/*
*  Card styles
*/
//styled components
const Card = styled.section`
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center; /*space-between;*/
  align-items: flex-start;

  padding: 0 2.3rem 0 1.8rem;
  margin-bottom: 2rem;
  min-height: 220px;
  //width:100%;
  //height:100%;
  //max-width: 75em;
  //min-width: 17em;
`;

//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822
const cardImageStyle =  {
  display: 'block',
  'maxHeight':'186px',
  width: 'auto',
  height: 'auto'
};

const ImageLabel = styled.section`
  padding: 1.0rem 0 1.0rem 0;
  height: 100%;
  width: 100%;
  color: #7d7874;
  font-size: 1.0em;
  line-height: 0.4em;
  text-align: left;
`;

  const ImageLabelLineProd = styled.section`
      //color: #FFF;
      font-size: 1.5rem;
      line-height:1.8rem;
      text-align: left;
    `;


const CardImageColumn = styled.section`
  height: 100%;  
  flex: 1 1 5%;
  flex-direction: column;
  padding-right: 1.5em;
  min-width: 17rem;
`;

const MoreInfoLinkStyle  = styled.section`
  padding: 0.5rem 0
  color:#507198;
  font-style: normal;
  text-align: left;
  font-size:  1em;
  line-height: 1.45em;
`;

const QuoteTextColumn = styled.section`
  flex: 1 1 73%;  //Causing quoteCard not to wrap
  height: 100%;
  //min-width: 300px;
  width: 100%;
  color: #507198;

  font-style: italic;
  text-align: left;
  font-size:  1.25em;
  line-height: 1.45em;
  `;